import BScroll from "better-scroll";
export const group = {
    data() {
        return {
            listHeight: [],
            menuScroll: {},
            listScroll: {},
            scrollY: 0,
            activateIndex: 0
        };
    },
    watch: {
        scrollY(v) {
            let index = 0;
            for (let i = 0; i < this.listHeight.length; i++) {
                const height1 = this.listHeight[i];
                const height2 = this.listHeight[i + 1];
                if (
                    !height2 ||
                    (this.scrollY >= height1 && this.scrollY < height2)
                ) {
                    index = i;
                    break;
                }
            }
            this.activateIndex = index;
        }
    },
    methods: {
        initGroup() {
            // DOM已经更新
            this.$nextTick(() => {
                // 执行滚动方法
                this.initScroll();
                // 计算分类的区间高度
                this.calculateHeight();
            });
        },
        initScroll() {
            this.menuScroll = new BScroll(this.$refs.menuScroll, {
                click: true
            });
            this.listScroll = new BScroll(this.$refs.listScroll, {
                probeType: 3,
                click: true
            });
            // listScroll监听事件
            this.listScroll.on("scroll", pos => {
                this.scrollY = Math.abs(pos.y);
            });
        },
        calculateHeight() {
            const bigList = this.$refs.listScroll.getElementsByClassName(
                "big-list"
            );
            let height = 0;
            this.listHeight.push(height);
            for (let i = 0; i < bigList.length; i++) {
                const item = bigList[i];
                // 累加
                height += item.clientHeight;
                this.listHeight.push(height);
            }
        },
        selectMenu(index) {
            const bigList = this.$refs.listScroll.getElementsByClassName(
                "big-list"
            );
            const element = bigList[index];
            this.listScroll.scrollToElement(element, 250);
            // 延时执行，保证当前选项最后被选中
            setTimeout(() => {
                this.activateIndex = index;
            }, 300);
        }
    }
}